import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import Switches from "./switches";
import Values from "./values";
/**
 * Collection of application level configuration options.
 */
class Application extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "application");
        this.switches = new Switches(sdk);
        this.values = new Values(sdk);
    }
    /**
     * Find the default settings. Currenlty only supports returning all the settings.
     * @return: a promise that resolves with all default settings.
     */
    async findItems() {
        throw new NotImplementedError("findItem");
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("delete");
    }
}
export default Application;
//# sourceMappingURL=index.js.map